import axios from "../utils/axios";

export const getValueItems = async (params) => {
    const { data } = await axios.get("/value-items", { params });
    return data;
};

export const getValueItemById = async (id) => {
    const { data } = await axios.get(`/value-items/${id}`);
    return data;
};

export const createValueItem = async (itemData) => {
    const { data } = await axios.post("/value-items", itemData);
    return data;
};

export const updateValueItem = async (id, itemData) => {
    const { data } = await axios.put(`/value-items/${id}`, itemData);
    return data;
};

export const deleteValueItem = async (id) => {
    const { data } = await axios.delete(`/value-items/${id}`);
    return data;
};

export const forceDeleteValueItem = async (id) => {
    const { data } = await axios.delete(`/value-items/${id}/force-delete`);
    return data;
};

export const restoreValueItem = async (id) => {
    const { data } = await axios.post(`/value-items/${id}/restore`);
    return data;
};

export const massDestroyValueItems = async (data) => {
    const response = await axios.delete("/value-items/mass-destroy", { data });
    return response.data;
};

export const massForceDeleteValueItems = async (data) => {
    const response = await axios.delete("/value-items/mass-force-delete", { data });
    return response.data;
};

export const massRestoreValueItems = async (data) => {
    const response = await axios.post("/value-items/mass-restore", data);
    return response.data;
};
